// Web safe mock implementation
export const crashlyticsUtil = {
  log: (_message: string) => {},
  setAttribute: (_key: string, _value: string) => {},
  setAttributes: (_attributes: Record<string, string>) => {},
  recordError: (_error: unknown) => {},
};